import * as types from './mutation-types'


export default {
  [types.ADD_AREAS] (state, data) {
    state.areas = data.data
  },

}
